import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5db0e289"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "multiselect-label text-mild text-size-14 mr-1" }, "銀行名", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "multiselect-label text-mild text-size-14 mr-1 bank-branch-select" }, "支店", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "multiselect-label text-mild text-size-14 mr-1 mt-3" }, "\n      口座種別\n    ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "\n      ※普通預金のみ設定可能です\n    ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-gray-05" }, "7桁までの数字", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-gray-05" }, "\n      ※口座名義はアカウントの基本情報から取得しています\n    ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "mt-4 text-weight-500" }, "報酬の受取について", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TextFieldGroup = _resolveComponent("TextFieldGroup")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_RewardDescription = _resolveComponent("RewardDescription")!
  const _component_BForm = _resolveComponent("BForm")!

  return (_openBlock(), _createBlock(_component_BForm, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(),
      _createVNode(_component_AppLabel, { variant: "red" }, {
        default: _withCtx(() => [
          _createTextVNode("必須")
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_Multiselect, {
        id: "id",
        ref: "multiselect",
        modelValue: _ctx.inputValues.selectedBank,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.selectedBank) = $event)),
        options: _ctx.inputValues.searchedBanks,
        "value-prop": "id",
        label: "name",
        placeholder: "銀行名を入力して検索できます",
        limit: 100,
        searchable: true,
        "can-clear": true,
        "can-deselect": false,
        object: true,
        "search-filter": _ctx.searchFilter,
        "no-results-text": "見つかりませんでした",
        "no-options-text": "1文字以上入力してください",
        onSearchChange: _ctx.aliasSearch
      }, null, 8, ["modelValue", "options", "search-filter", "onSearchChange"]),
      _createTextVNode(),
      _hoisted_2,
      _createTextVNode(),
      _createVNode(_component_AppLabel, { variant: "red" }, {
        default: _withCtx(() => [
          _createTextVNode("必須")
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(_component_Multiselect, {
        id: "id",
        ref: "multiselect",
        modelValue: _ctx.selectedBranch,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedBranch) = $event)),
        options: _ctx.searchedBranches,
        "value-prop": "id",
        label: "name",
        placeholder: "支店名・支店コードで検索できます",
        limit: 100,
        searchable: true,
        "can-clear": true,
        "can-deselect": false,
        object: true,
        "search-filter": _ctx.searchBankBranchFilter,
        "no-results-text": "見つかりませんでした",
        "no-options-text": "1文字以上入力してください",
        onSearchChange: _ctx.aliasSearchBankBranch
      }, null, 8, ["modelValue", "options", "search-filter", "onSearchChange"]),
      _createTextVNode(),
      _hoisted_3,
      _createTextVNode(),
      _hoisted_4,
      _createTextVNode(),
      _createVNode(_component_ValidationProvider, {
        name: "口座番号",
        rules: { required: true, min_account_number: 7, max: 7 },
        vid: "accountNumber",
        modelValue: _ctx.inputValues.accountNumber,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValues.accountNumber) = $event))
      }, {
        default: _withCtx((validationState) => [
          _createVNode(_component_TextFieldGroup, {
            modelValue: _ctx.inputValues.accountNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValues.accountNumber) = $event)),
            label: "口座番号",
            appLabelText: "必須",
            placeholder: "1000000",
            inputmode: "numeric",
            validationState: validationState,
            class: "mt-3"
          }, null, 8, ["modelValue", "validationState"]),
          _createTextVNode(),
          _hoisted_5
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createTextVNode(),
      _createVNode(_component_TextFieldGroup, {
        value: _ctx.holderName,
        label: "口座名義",
        placeholder: "",
        class: "mt-3",
        disabled: true
      }, null, 8, ["value"]),
      _createTextVNode(),
      _hoisted_6,
      _createTextVNode(),
      _hoisted_7,
      _createTextVNode(),
      _createElementVNode("dd", null, [
        _createVNode(_component_RewardDescription)
      ]),
      _createTextVNode(),
      _renderSlot(_ctx.$slots, "footerButton", {}, undefined, true)
    ], undefined, true),
    _: 3
  }))
}